import { useState } from "react";

export default function ContactMe () {
    const [complete, setComplete] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");

    function encode(data) {
        return Object.keys(data).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])).join("&");
    }

    function submit(e) {
        fetch("/", {
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            body: encode({
                "form-name": e.target.getAttribute("name"),
                name, email, subject, message
            })
        }).then(() => {
            setComplete(true);
            setName("");
            setEmail("");
            setSubject("");
            setMessage("");
        }).catch(err => alert(err));

        e.preventDefault();
    }

    return (
        <>
            <h1 className="title">Contact Me <div className="title__underline"/></h1>

            <div className="contact-me">
                {complete && <div className="contact-me__message">Thank you for your message, I'll be in touch as soon as I can</div>}

                <form className="form" name="Contact Me" method="POST" onSubmit={submit}>
                    <input type="hidden" name="form-name" value="contact" />
                    <input className="form__input" type="text" placeholder="Name" required value={name} onChange={(e) => setName(e.target.value)} />
                    <input className="form__input" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                    <input className="form__input" type="text" placeholder="Subject" required value={subject} onChange={(e) => setSubject(e.target.value)} />
                    <textarea className="form__textarea" placeholder="Message..." required value={message} onChange={(e) => setMessage(e.target.value)} />
                    <div className="contact-me__footer" title="Feel free to write your own email and send to this address">
                        <a className="chip chip--pointer" href="mailto:tobysx@gmail.com">
                            <i className="fas fa-envelope"/> tobysx@gmail.com
                        </a>
                        <input className="form__submit" type="submit" value={complete ? "Thank You" : "Submit"} />
                    </div>
                </form>
            </div>
        </>
    );
}
